import {Virtuoso} from 'react-virtuoso'
import styled, {css} from 'styled-components'

export const StyledBudgetExternalCosts = styled.div(
    ({theme: {spacing}}) => css`
        height: 100%;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        & > div:first-child {
            padding: ${spacing * 4}px ${spacing * 6}px;
        }
    `
)

export const StyledBudgetExternalCostsList: typeof Virtuoso = styled(Virtuoso)(
    ({theme: {spacing}}) => css`
        & > div {
            padding: 0 ${spacing * 6}px;
            gap: ${spacing * 12}px;

            & .list-item {
                margin: ${spacing * 4}px 0;
                &:last-child {
                    padding-bottom: ${spacing * 4}px;
                }
            }
        }
    `
)
